import Hls from "hls.js";
import { useEffect, useRef } from "react";

import { getAccessToken } from "../auth/accessToken";

function Player({ message }) {
  const audioRef = useRef();

  const id = message.message_guid ?? message._id;

  useEffect(() => {
    const hlsRef = { current: null };
    let cancelled = false;

    (async () => {
      const token = await getAccessToken();
      if (cancelled || !token || !audioRef.current) {
        return;
      }

      const baseUrl = `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_STREAM_PATH}/${id}`;

      const audioSrc = `${baseUrl}/stream.m3u8?pxtoken=${encodeURIComponent(
        token
      )}`;

      if (Hls.isSupported()) {
        hlsRef.current = new Hls({
          xhrSetup: function (xhr, url) {
            var s3BaseUrl = `https://pxmessages.s3.us-east-2.amazonaws.com/stream/${id}`;
            if (url.startsWith(s3BaseUrl)) {
              url = url.replace(s3BaseUrl, baseUrl);
              xhr.open("GET", url, true);
              xhr.setRequestHeader("pxtoken", token);
              xhr.setRequestHeader("Authorization", `Bearer ${token}`);
            }
          },
        });
        hlsRef.current.loadSource(audioSrc);
        hlsRef.current.attachMedia(audioRef.current);
      } else if (audioRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        audioRef.current.src = audioSrc;
      }
    })();

    return () => {
      cancelled = true;
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, [id]);

  return (
    <>
      <audio ref={audioRef} controls style={{ width: "100%" }} />
    </>
  );
}

export default Player;
